/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 *
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.36.0
 */

import { EBasketType, EOperation } from '@/main/modules/app/appConstants';

import { IWizardFastAcions } from '../appRouterTypes';
import { RoutePath } from './routesConstants';

export const WizardFastActionsRouteConfiguration: IWizardFastAcions[] = [
    {
        basketType: EBasketType.MAIN_OPERATIONS,
        path: RoutePath.wizardFastBillsDoc,
        operation: EOperation.BILL_INVOICE,
    },
    {
        basketType: EBasketType.MAIN_OPERATIONS,
        path: RoutePath.wizardFastReportDoc,
        operation: EOperation.REPORT_DOCUMENTS,
    },
];
